module.exports = __webpack_public_path__ + "media/images/front/home_video_m-280e31a4ddc951ae6138fb0c829c2d84.webm";